import React, { Component } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import ImageBackground from "../common/imageBackground";
import PatientBanner from "../common/patientBanner";
import CareTeamList from "./CareTeamList";
import CareTeamDetail from "./CareTeamDetail";
import CareTeamSurvey from "./CareTeamSurvey";
import "./styles.css";

class Service1274 extends Component {
  /**************
   * Properties *
   **************/
  state = {
    bannerVisible: true,
  };

  showBanner() {
    return !this.props.location.pathname.includes("/care_team/survey");
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1274">
        <ImageBackground id="background" />
        <PatientBanner visible={this.showBanner()} />
        <Switch>
          <Route path="/care_team/list" component={CareTeamList} />
          <Route
            path="/care_team/details/:name/:page"
            component={CareTeamDetail}
          />
          <Route
            path="/care_team/survey/:name/:popup"
            component={CareTeamSurvey}
          />
          <Route path="/care_team/survey/:name" component={CareTeamSurvey} />
          <Route
            path="/care_team"
            render={() => <Redirect to="/care_team/list" />}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1274);
